export default function getCurrentLocation () {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(setPosition, noSetPosition)
    } else {
      noSetPosition()
    }
    function setPosition (position) {
      resolve({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
      })
    }
    function noSetPosition () {
      resolve({})
    }
  })
}
